import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddExtensionActions from './add-extension.actions';

export const addExtensionFeatureKey = 'addExtension';

export interface AddExtensionState {
   callState: CallState;
}

export const initialState: AddExtensionState = {
   callState: LoadingState.Init,
};

const addExtensionReducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddExtensionActions.createExtension, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AddExtensionActions.createExtensionSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AddExtensionActions.createExtensionFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);

export function reducer(state: AddExtensionState | undefined, action: Action) {
   return addExtensionReducer(state, action);
}
